import { useState, useEffect } from "react";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";
import BlogPostCard from "../components/blogPostCard";

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsQuery = query(
          collection(db, "blog_posts"),
          orderBy("createdAt", "desc"),
          limit(10)
        );

        const querySnapshot = await getDocs(postsQuery);
        const postsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPosts(postsList);
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <main>
      <div className="line-top line-bottom text-small text-center">
        <div className="main-inner">
          {loading ? (
            <p>Loading posts...</p>
          ) : posts.length > 0 ? (
            <div className="posts-grid">
              {posts.map((post) => (
                <BlogPostCard
                  key={post.id}
                  slug={post.slug}
                  title={post.title}
                  author={post.author}
                  date={post.createdAt.toDate().toLocaleDateString()}
                  readTime={post.readTimeMins}
                  imageUrl={post.imageUrl}
                  tags={post.tags}
                />
              ))}
            </div>
          ) : (
            <p>No posts found</p>
          )}
        </div>
      </div>
    </main>
  );
}
